import React, { useEffect, useState } from 'react';
import { useNotification } from './NotificationContext';
import NotificationPopup from './NotificationPopup';
// import AdjustPriceModal from './AdjustPriceModal';
import './NotificationContainer.css';
import Grab_Order_Popup from '../Grab_Order_Popup';
import { Actions } from '../../../Actions/Actions';
import bellIcon from '../../../assets/images/notification-bell-red.png';
import { useDispatch } from 'react-redux';
import { mapGrabOrderNotification } from '../../../utilities/conversion';
import api from '../../../seller-apis/api';
import { useAlert } from 'react-alert';
import { setRemainingGrabOrderNotificationCount } from '../../../utilities/grabOrderNotificationStorage';


const NotificationContainer = () => {
  const {
    notifications,
    notificationQueue,
    showNextNotification,
    closeNotification,
    clearAllNotifications
  } = useNotification();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProductData, setSelectedProductData] = useState({});
  const dispatch = useDispatch()
  const alert = useAlert();

  useEffect(() => {
    if (notificationQueue.length > 0) {
      showNextNotification();
    }
  }, [notificationQueue, showNextNotification]);

  // const handleAdjustPrice = (id) => {
  //   const notification = notifications.find(n => n.id === id);
  //   if (notification) {
  //     setSelectedProductData(notification);
  //     setIsModalOpen(true);
  //     closeNotification(notification, true)
  //   }
  // };

  const handleGrabOrder = (id) => {
    const notification = notifications.find(n => n.id === id);
    const mappedNotification = mapGrabOrderNotification(notification);
    if (notification) {
      Actions.updateGrabOrderPopupState(dispatch, {
        visible: true,
        data: mappedNotification,
        disableTimer: true
      });
      closeNotification(notification, true)
    }
  };

  const handleClearAll = () => {
    // Clear all grab order notifications
    api.order.markAllUnreadGrabOrdersAsRead().then(() => {
      alert.success('All grab orders closed successfully.');
      setRemainingGrabOrderNotificationCount(0);
     clearAllNotifications()
    });
  };

  const handleModalClose = (data, markAsRead) => {
    setIsModalOpen(false);
    setSelectedProductData({});
    closeNotification(data, markAsRead)
  };

  const grabOrderNotifications = notifications.filter(
    (notification) => notification.type === 'grab_order'
  );
  const visibleGrabOrders = grabOrderNotifications.filter(
    (notification) => notification.isVisible
  );

  if (grabOrderNotifications.length === 0 && notificationQueue.length === 0) {
    return null;
  }

  const notificationHeight = 76;
  const headerHeight = 45;
  const calculatedHeight =
    headerHeight + Math.max(visibleGrabOrders.length, 0) * notificationHeight;
  const maxHeight = 600;
  const dynamicHeight = Math.min(calculatedHeight, maxHeight);

  return (
    <div className="notification-container">
      <div className="grab-order-popup" style={{ height: `${dynamicHeight}px` }}>
        <div className="popup-header">
          <h6 className="popup-title">
            <img src={bellIcon} alt="Grab Order" style={{ width: '18px', height: '18px',marginRight:'2px' }} />
           Grab Order ({visibleGrabOrders.length + notificationQueue.length})</h6>
          <button className="clear-all-btn" onClick={handleClearAll}>
            <i className="bi bi-x-circle"></i> Close All
          </button>
        </div>
        <div className="notifications-list">
          {visibleGrabOrders.map((notification, index) => (
            <NotificationPopup
              key={notification.id}
              notification={notification}
              onClose={closeNotification}
              // onAdjustPrice={handleAdjustPrice}
              onGrabOrder={handleGrabOrder}
              index={index}
            />
          ))}
        </div>
      </div>

      {/* Adjust Price Modal */}
      {/* <AdjustPriceModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        productData={selectedProductData}
        receivedFrom="order_lost"
      /> */}

      <Grab_Order_Popup
        onClose={handleModalClose}
        receivedFrom="grab_order_popup"
      />
    </div>
  );
};

export default NotificationContainer;
